import React, { Component } from 'react';
import { withStyles } from "@material-ui/core/styles";
import { NavLink } from "react-router-dom";
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';

class HeaderComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            placement: "",
        }
    }

    logOut = () => {        
        this.props.actions.logout();
        this.props.history.push(process.env.PUBLIC_URL + "/login");
    }

    render() {        
        const { classes } = this.props;
        let username = this.props.authReducer.username;

        const handleClick = (newPlacement) => (event) => {
            this.setState({ anchorEl: this.state.anchorEl ? null : event.currentTarget })
            this.setState({ placement: newPlacement })
        };

        const open = Boolean(this.state.anchorEl);
        const id = open ? 'simple-popper' : undefined;

        return (
            <div className={classes.headerComponent}>
                <div className={classes.imgLogo}>
                    <img className={classes.img} src={process.env.PUBLIC_URL + '/img/mydibelHeaderLogo.png'}></img>
                </div>
                <div className={classes.links}>
                    
                </div>
                <div className={classes.user}>
                    <div className={classes.imgLogOut}>
                        <button className={classes.logoutButton} aria-describedby={id} type="button" onClick={handleClick('bottom-end')}>
                            <img src={process.env.PUBLIC_URL + '/img/icon_down.png'}></img>
                        </button>
                        <Popper id={id} open={open} anchorEl={this.state.anchorEl} placement={this.state.placement} transition>
                            {({ TransitionProps }) => (
                                <Fade {...TransitionProps} timeout={500}>
                                    <div className={classes.paper} onClick={this.logOut}>Logout</div>
                                </Fade>
                            )}
                        </Popper>
                    </div>
                    <div className={classes.hiUser}>
                        Hi, {username}
                    </div>
                    <div className={classes.imgUser}>
                        <img src={process.env.PUBLIC_URL + '/img/user.png'}></img>
                    </div>
                </div>

            </div>
        )
    }
}

const styles = {
    headerComponent: {
        height: "105px",
        width: "100%",
        backgroundColor: "white",
        boxShadow: "0px 3px 6px #00000029"
    },
    imgLogo: {
        float: "left"
    },
    img: {
        marginTop: "10px",
        marginLeft: "39px"
    },
    links: {
        float: "left",
        paddingTop: "40px",
        marginLeft: "70px",
        width: "auto"
    },
    transportOrdersLink: {
        float: "left",
        fontFamily: "proxima-nova, sans-serif",
        fontSize: "20px",
        color: "#616A6E",
        textDecoration: "none"
    },
    transportOrdersHistoryLink: {
        float: "left",
        marginLeft: "45px",
        fontFamily: "proxima-nova, sans-serif",
        fontSize: "20px",
        color: "#616A6E",
        textDecoration: "none"
    },
    transportOrdersActiveLink: {
        float: "left",
        fontFamily: "proxima-nova, sans-serif",
        fontSize: "20px",
        color: "#1583C3",
        fontWeight: "bold",
        textDecoration: "underline"
    },
    transportOrdersHistoryActiveLink: {
        float: "left",
        marginLeft: "45px",
        fontFamily: "proxima-nova, sans-serif",
        fontSize: "20px",
        color: "#1583C3",
        fontWeight: "bold",
        textDecoration: "underline"
    },
    imgUser: {
        float: "right"
    },
    imgLogOut: {
        float: "right",
        marginRight: "40px"
    },
    hiUser: {
        float: "right",
        fontFamily: "proxima-nova, sans-serif",
        fontSize: "18px",
        color: "#616A6E",
        fontWeight: "bolder",
        marginLeft: "8px",
        marginRight: "8px"
    },
    user: {
        paddingTop: "40px"
    },
    logoutButton: {
        backgroundColor: "white",
        border: "0px",
        outline: "none",
        cursor: "pointer"
    },
    paper: {
        border: "1px solid",
        fontFamily: "proxima-nova, sans-serif",
        fontSize: "16px",
        color: "#616A6E",
        padding: "20px",
        backgroundColor: "white",
        marginTop: "10px",
        cursor: "pointer"
    }
};

export default withStyles(styles)(HeaderComponent);